// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"308":"bcc5145e","388":"d9abfc63","433":"5dfa8906","798":"d9abfc63","819":"bcc5145e"}[chunkId] + ".chunk.css";
};